import { fetch } from '@atlassian/eoc-fetch';

import {
	type AlertPolicy,
	type AlertPolicyResponse,
	type ChangeAlertPolicyOrderParamsWithTeamId,
	type ChangeAlertPolicyStateParamsWithTeamId,
	type CreatePolicyParamsWithTeamId,
	type GlobalAlertPolicyResponse,
	type NotificationPolicy,
	type NotificationPolicyResponse,
	type PolicyMaintenanceRights,
	type UpdatePolicyParams,
	type UpdateUIPreferenceParams,
} from '../../common/types';

export const getTeamPolicies = (teamId: string) => {
	return fetch<AlertPolicyResponse>(`/v1/teams/${teamId}/policies?type=alert`);
};

export const getGlobalPolicies = (teamId?: string | null) => {
	if (teamId) {
		return fetch<GlobalAlertPolicyResponse>(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
	}

	return fetch<GlobalAlertPolicyResponse>(`/v1/alerts/policies`);
};

export const getNotificationPolicies = (teamId: string) => {
	return fetch<NotificationPolicyResponse>(`/v1/teams/${teamId}/policies?type=notification`);
};

export const getPolicyMaintenanceRights = () => {
	return fetch<PolicyMaintenanceRights>(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};

export const updateUIPreferenceEndpoint = ({ teamId, ...payload }: UpdateUIPreferenceParams) => {
	let url = `/v1/alerts/ui-preferences/policies`;

	if (teamId) {
		url = `${url}?teamId=${teamId}`;
	}

	return fetch(url, {
		method: 'PATCH',
		body: payload,
		responseType: 'headers',
	});
};

export const changePolicyOrderEndpoint = (payload: ChangeAlertPolicyOrderParamsWithTeamId) => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
		method: 'PATCH',
		body: { after: payload.after },
		responseType: 'headers',
	});
};

export const enablePolicyEndpoint = (payload: ChangeAlertPolicyStateParamsWithTeamId) => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const disablePolicyEndpoint = (payload: ChangeAlertPolicyStateParamsWithTeamId) => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const deletePolicyEndpoint = (payload: ChangeAlertPolicyStateParamsWithTeamId) => {
	return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};

export const createPolicyEndpoint = (payload: CreatePolicyParamsWithTeamId) => {
	return fetch<AlertPolicy | NotificationPolicy>(`/v1/teams/${payload.teamId}/policies`, {
		method: 'POST',
		body: payload,
	});
};

export const updatePolicyEndpoint = (payload: UpdatePolicyParams) => {
	return fetch<AlertPolicy | NotificationPolicy>(
		`/v1/teams/${payload.teamId}/policies/${payload.id}`,
		{
			method: 'PUT',
			body: payload,
		},
	);
};
